// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"f9fefbf9","139":"f9fefbf9"}[chunkId] + ".chunk.css";
};